export default __webpack_public_path__ + "static/media/twitter.df592a88.svg";